import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;

  button {
    padding: 0.4rem 1.5rem;
    margin: 1.4rem 0 0 1rem;
  }
`;
